// The muted " · Team" suffix on a card stat row's left cell. The team name is a
// blue link to the team page when a teamId is present (matches league/stats),
// otherwise plain muted text (Career/total rows carry no single team). Uses a
// full <a> nav like league/stats — clicking leaves the modal for the team page.
export function CardTeamLink({ teamId, team }: { teamId?: number | null; team?: string | null }) {
  if (!team) return null
  return (
    <span className="font-normal text-slate-400">
      {' · '}
      {teamId != null ? (
        <a href={`/team/${teamId}/view`} className="text-blue hover:underline">{team}</a>
      ) : (
        team
      )}
    </span>
  )
}
